import React from 'react'

function SuperE2() {
  return (
    <div>
      <p>
Whether you would like to invest in your child’s education or your own, Super E Plus gives you the chance to make those investments that count. Your dream home, the plot of prime land you had your eye on or even your business expansion plans. Really, Super E Plus allows you to make your investment dreams a reality. How does it help you invest</p>

<div className="my-4">
      <ul className="list-disc list-inside">
      <li>It provides 6 bonuses totalling 130% of the sum assured and a lump sum of 100% of the sum assured at the end of the term. </li>
      <li>You can also take a loan of up to 80% of the value of your policy. Imagine how much further your business could be with access to such capital. It could be the down payment to your dream home.</li>
      <li>For policies lasting more than 10 years, you are entitled to a tax relief of up to 15% of the premium paid. Better yet, the full amount payable at the end of the policy is completely tax free.</li>
      <li>In case you miss a payment, all is not lost, you have until 60 days to pay your arrears and proceed with your policy as normal.</li>





        </ul>
        </div>





    </div>
  )
}

export default SuperE2